const AdvanceSearchTip = () => {
    return (
        <div className="w-full border-2 border-main h-[70vh] overflow-y-auto mt-4 text-left p-4 text-grey">
          <div className="text-2xl font-bold mb-4">Advanced search options</div>
          <div>
          <span className="font-bold">Exact phrases:</span> Search for exact phrases within the archive by enclosing the phrase in quotation marks. Example: "algorithmic management".
          <br/>
          <br/>
          <span className="font-bold">Multiple terms:</span> Search for the presence, or absence, of multiple terms within search fields by using Boolean operators. These operators must be entered in UPPERCASE to function correctly.
          <br/>
          <br/>

          <span className="font-bold">Examples:</span>
          <br/>
          <ul className="list-disc list-inside">
            <li>"algorithmic AND management" yields all results with both words present</li>
            <li>"management NOT algorithmic" yields all results with "management" present and "algorithmic" not present</li>
          </ul>
          <br/>


          <span className="font-bold">Wildcards:</span> Use a question mark (?) in a search term to represent a single character (e.g., wom?n finds "women" or "woman"). Use an asterisk () to represent zero or more characters. For example, work* finds all words with that root (worker, working). Wildcards CANNOT be used at the start of a search term (*tension) or when searching for phrases in quotes (“tobacco smok*”).
          </div>
        </div>
    )
}

export default AdvanceSearchTip;